import type { FC } from 'react';

import type { IconProps } from './types';

const MagnifyingGlassPlus: FC<IconProps> = ({ color = 'currentColor', ...props }) => (
  <svg width="24" height="24" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M630.552 433.845c0 21.728-17.614 39.342-39.342 39.342H473.185v118.025c0 21.728-17.614 39.342-39.342 39.342s-39.342-17.614-39.342-39.342V473.187H276.476c-21.728 0-39.342-17.614-39.342-39.342s17.614-39.342 39.342-39.342h118.025V276.478c0-21.728 17.614-39.342 39.342-39.342s39.342 17.614 39.342 39.342v118.025H591.21c21.728 0 39.342 17.614 39.342 39.342zm381.909 578.617c-7.121 7.128-16.962 11.538-27.834 11.538s-20.713-4.41-27.834-11.538l-246.18-246.229c-74.561 62.443-171.509 100.365-277.314 100.365C193.995 866.598 0 672.603 0 433.299S193.995 0 433.299 0c239.304 0 433.299 193.995 433.299 433.299 0 105.806-37.923 202.753-100.919 277.993l.553-.679 246.229 246.18c7.128 7.121 11.538 16.962 11.538 27.834s-4.41 20.713-11.538 27.834zM433.844 787.92c195.55 0 354.075-158.525 354.075-354.075S629.394 79.77 433.844 79.77c-195.55 0-354.075 158.525-354.075 354.075.224 195.46 158.614 353.851 354.054 354.075h.021z"
      fill={color}
    />
  </svg>
);

export default MagnifyingGlassPlus;
